import React, { useEffect, useState } from "react";
import Header from "../components/dynamic/Header";
import ActionButton from "../components/dynamic/ActionButton";
import useOauthStore from "../store/ouathStore";
import plutoSdk from "../plutoSdk";

const CredentialView: React.FC = () => {
  const oauth = useOauthStore((state) => state.oauth);
  const cancellationError = useOauthStore((state) => state.cancellationError);
  const [logo, setLogo] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      const parsedHost = new URL(oauth.auth_code_url).hostname
        .split(".")
        .slice(-2)
        .join(".");
      setLogo(`https://logo.clearbit.com/${parsedHost}`);
    })();
  }, [oauth]);

  if (!oauth) {
    return null;
  }

  const requestOauth = async () => {
    if (cancellationError) {
      useOauthStore.getState().setCancellationError(undefined);
    }
    plutoSdk.requestOauth(oauth.auth_code_url);
  };

  return (
    <div className="flex flex-col flex-1 h-full justify-between">
      <div className=" flex flex-col items-center">
        {logo && <img src={logo} alt="Logo" onError={() => setLogo(null)} />}
        <div className="mt-28">
          <Header title={oauth?.title} subheader={oauth?.description} />
        </div>
        {cancellationError && (
          <div className="flex flex-col gap-1 rounded-lg bg-blue-50 border border-blue-200 p-3 shadow-sm">
            <div className="flex items-center justify-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-blue-700 font-medium">
                {cancellationError.error}
              </span>
            </div>
            <p className="text-blue-600 text-sm break-words whitespace-pre-wrap mt-1">
              {cancellationError.errorDescription}
            </p>
          </div>
        )}
      </div>

      <div className="w-full">
        <ActionButton
          label={cancellationError ? "Try Again" : "Continue"}
          onClick={requestOauth}
        />
      </div>
    </div>
  );
};

export default CredentialView;
